import { useTheme } from '@pata-app/themes';
import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { testimonialOptions, Testimoninal } from '../../../../components/testimoninal/testimoninal';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';

const TestimoninalTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Why <strong>pet massage therapists </strong>
        trust Pata booking software
      </h2>
    </TextWithHighlight>
  );
};

const TestimoninalSubTitle = () => {
  return (
    <p style={{ maxWidth: '850px' }}>
      We think our booking software can change the way you run your business, but don’t just take our word for it.
      Here’s why pet massage therapists love using Pata to manage appointments, view medical notes, and simplify admin
      for their clinic.
    </p>
  );
};

export function HydrotherapyTestimoninal() {
  const theme = useTheme();

  const hydroTherapyTestimoninalConfig = [
    {
      children: testimonialOptions.canine_body_works,
      color: theme.core.colors.primary.blue.medium,
    },
  ];

  return (
    <WidthContainer noBackground>
      <SectionContainer title={TestimoninalTitle} subTitle={TestimoninalSubTitle}>
        <Testimoninal testimonialConfig={hydroTherapyTestimoninalConfig} />
      </SectionContainer>
    </WidthContainer>
  );
}
